import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import React from 'react'
import reportWebVitals from './reportWebVitals'
import { createRoot } from 'react-dom/client'
import { App } from 'app/App';
import './shared/style/global.css';

const root = createRoot(
    document.getElementById('root') as HTMLElement
)

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

const loader = document.getElementById('loader-container') as HTMLElement
loader.classList.add('loader-container_finish')

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
